import { getTemplatesLanguages, getTemplatesList } from 'apps/whatsApp/redux/messageTemplatesSlice'
import {
  NodePreloadRulePayload,
  PreloaderRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { BlockType } from 'common/builder/constants/BlockType'
import { NodeType } from 'common/builder/constants/NodeType'
import { INode, IWhatsAppNode } from 'common/builder/nodes/nodeInterfaces'

export const MessageTemplateNodeWhatsAppPreloaderRule: PreloaderRule<
  IWhatsAppNode,
  NodePreloadRulePayload
> = {
  predicate: (entity: INode, payload) => {
    if (entity.nodeType !== NodeType.WHATS_APP) {
      return false
    }

    const messageTemplateBlock = entity.blocks.find(
      (blockId) => payload.blocks[blockId]?.type === BlockType.MESSAGE_TEMPLATE,
    )

    return Boolean(messageTemplateBlock)
  },

  getKey: () => 'wa_message_template',

  createLoader:
    (_, { dispatch }) =>
    () =>
      Promise.all([dispatch(getTemplatesLanguages()), dispatch(getTemplatesList())])
        .then(() => true)
        .catch(() => false),
}
